import {
  LoadingSpinner,
  Message,
  MessageStatus
} from "@app/form_components";
import { defaultServiceContext } from "../../contexts";
import { AppVersioningService } from "../../services";
import BaseDialog from "./BaseDialog";

const moment = require("moment");

const { avsService } = defaultServiceContext;

export default class MergeBranchDialog extends BaseDialog {
  /**
   * Dialog for listing branch data on main branch, and actions to initialize branch merge to main
   * @module MergeBranchDialog
   * @param {Object} props React props
   */
  constructor(props) {
    super(props);

    this.state = {
      selected: null,
      selectionLoaded: false,
      branchList: [],
      branchNameFilter: '',
    };

    this.setSelected = this.setSelected.bind(this);
  }

  componentDidMount() {
    this.getBranchInfoList().then((options) => {
      this.setState({ init: true, branchList: options });
    });
  }

  setSelected = (e) => {
    const tableRows = $(e.currentTarget).parent().children();

    tableRows.each((idx, row) => {
      $(row).find("input").prop("checked", false);
    });

    $(e.currentTarget).find("input").prop("checked", true);
    $(`#${this.props.mergePreviewButtonId}`).prop("disabled", false);

    const selected = this.state.branchList.find((bl) => {
      return bl.application === e.currentTarget.dataset.values.split("::")[1];
    });

    this.setState({ selected });
  };

  async getBranchInfoList() {
    const { branchingMap, designId } = this.props.serialized;

    return (await avsService.getBranches(designId)).filter(({ name }) => {
      return name !== AppVersioningService.mainBranchName;
    }).map(({
      id,
      latestVersion,
      name
    }) => {
      const lastMergeEvent = branchingMap[id]?.filter((branchEvent) => branchEvent.type === "merge").pop() ?? null;
      const isMerged = lastMergeEvent ? lastMergeEvent.merged_at === latestVersion : false;

      return {
        application: name,
        branchId: id,
        isMerged,
        lastMergeEvent,
        version: latestVersion
      };
    }).sort((a, b) => {
      if (a.isMerged === b.isMerged) {
        return a.application.localeCompare(b.application);
      }
      return a.isMerged ? 1 : -1;
    });
  }

  getBranchRows() {
    const { branchNameFilter, branchList, init } = this.state

    if (!init) {
      return (
        <tr>
          <td colSpan={4} align="center">
            Loading branches...
          </td>
        </tr>
      )
    }

    const filteredBranches = (!branchNameFilter) ? branchList : (
      branchList.filter((b) =>
        b.application.toLowerCase().includes(branchNameFilter.toLowerCase())
        || b.version.toLowerCase().includes(branchNameFilter.toLowerCase())
      )
    );

    if (!filteredBranches.length) {
      return (
        <tr>
          <td colSpan={4} align="center">
            No results found
          </td>
        </tr>
      )
    }

    return filteredBranches.map(({
      application,
      branchId,
      isMerged,
      lastMergeEvent,
      version
    }) => {
      const lastMergedVersion = lastMergeEvent ? lastMergeEvent.merged_at : "-";
      const timestamp = lastMergeEvent ? lastMergeEvent.timestamp : undefined;
      const lastMergedDuration = timestamp ? moment.duration(moment(timestamp).diff(moment())).humanize(true) : undefined

      return (
        <tr
          key={branchId}
          data-values={`${branchId}::${application}::${version}`}
          onClick={this.setSelected}
          className={isMerged ? "disabled" : ""}>
          <td className="input"><input type="radio" /></td>
          <td className="name">{application}</td>
          <td className="version">{version}</td>
          <td className="lastMerged">
            {lastMergedVersion && <>{lastMergedVersion} <time className="duration" dateTime={timestamp}>{lastMergedDuration}</time></>}
          </td>
        </tr>
      );
    });
  }

  /**
   * React render
   * @returns {XML}
   */
   render() {
    const { branchListContainerHeight, serialized } = this.props;
    const { clientName, designName, version } = serialized;

    return (
      <div className="wrapper">
        {this.state.savingToRepo && (
          <LoadingSpinner message="saving to repo..." />
        )}
        <div className="content">
          <h2>Current Application</h2>
          <table>
            <tbody>
              <tr>
                <td className="no-padding">Client:</td>
                <th>{clientName}</th>
                <td>Application:</td>
                <th>{designName}</th>
                <td>Version:</td>
                <th>{version}</th>
              </tr>
            </tbody>
          </table>

          <div className="merge_branch_container">
            <h2>Select a branch to merge into application</h2>
            {this.props.isHotfix && (
              <Message
                message="Trying to merge a hotfix branch created from a newer version of main will fail."
                status={MessageStatus.warning}
              />
            )}
            <div>
              <i className="fe icon-search input-prefix-icon"></i>
              <input
                disabled={!this.state.init}
                type="search"
                className="form-component v-marginal search"
                placeholder={window.l.popup.search}
                onChange={(e) =>
                  this.setState({ branchNameFilter: e.target.value })
                }
              />
            </div>
            <div>
              <div className="headerContainer">
                <table className="branchListTableHeader">
                  <thead>
                    <tr>
                      <th></th>
                      <th className="name">Branch Name</th>
                      <th className="version">Latest Version</th>
                      <th className="lastMerged">Last Merged</th>
                    </tr>
                  </thead>
                </table>
              </div>

              <div
                className="branchListContainer"
                style={{ maxHeight: `${branchListContainerHeight}px` }}
              >
                <table>
                  <tbody>{this.getBranchRows()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
